export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 10 Cash Or Cheque.1baaeb91.mp3";